import './restore-employee.scss'
import React, { useState } from 'react'
import { OpenedLockIcon } from '@entur/icons'
import { OverflowMenuItem } from '@entur/menu'
import { RestoreEmployeeModal } from './restore-employee-modal'

export const RestoreEmployee: React.FC = () => {
  const [open, setModalOpen] = useState(false)

  const openModal = React.useCallback(() => setModalOpen(true), [setModalOpen])
  const closeModal = React.useCallback(() => setModalOpen(false), [setModalOpen])

  return (
    <>
      <OverflowMenuItem
        className="restore-employee-overflow-item"
        data-cy="restore-employee-overflow-item"
        onSelect={openModal}
      >
        <span aria-disabled>
          <OpenedLockIcon inline />
          Åpne profil
        </span>
      </OverflowMenuItem>
      <RestoreEmployeeModal open={open} close={closeModal} />
    </>
  )
}
